import React from 'react';
import type { SVGDefaultProps } from './types';
import { colors } from '@/styles';

export const Record = ({
  size = 14,
  title = 'Record',
  fill = colors.silverSandAlt,
}: SVGDefaultProps) => {
  const height = Number(size) * 2.85;

  return (
    <svg
      className="svg-record record-red"
      viewBox="0 0 33.3 33.3"
      height={height}
      xmlns="http://www.w3.org/2000/svg"
    >
      {Boolean(title) && <title>{title}</title>}
      <path
        d={`
M28.4,4.9C25.3,1.7,21.1,0,16.7,0h0C7.5,0,0,7.5,0,16.7c0,4.4,1.8,8.7,4.9,11.8
c3.1,3.1,7.4,4.9,11.8,4.9h0c9.2,0,16.6-7.5,16.7-16.7C33.4,12.2,31.6,8,28.4,
4.9z M30.1,16.7c0,7.4-6,13.4-13.4,13.4
c-7.4,0-13.4-6-13.4-13.4c0-7.4,6-13.4,13.4-13.4C24.1,3.3,30.1,9.3,30.1,16.7L30.1,16.7z
`}
        fill={fill}
      />
      <ellipse cx="16.7" cy="16.7" rx="9.6" ry="9.6" fill={fill} />
    </svg>
  );
};
